import 'core-js/stable'
import React from 'react'
import { createRoot } from 'react-dom/client'
import Clarity from '@microsoft/clarity'
import { init as initBugJar } from '@arvoretech/bug-jar'
import App from './App'
import { ARVORE_API_ENDPOINT } from './config/vars'
import {
  applyDeviceIdleAction,
  startDeviceIdleWatch
} from './utils/device-idle'

try {
  initBugJar({ debugSessionEndpoint: `${ARVORE_API_ENDPOINT}/debug-sessions` })
} catch {
  console.warn('[BugJar] Failed to initialize')
}

const clarityProjectId = process.env.CLARITY_PROJECT_ID
if (typeof window !== 'undefined' && clarityProjectId) {
  try {
    Clarity.init(clarityProjectId)
    window.clarity?.('consentv2', {
      analytics_Storage: 'granted',
      ad_Storage: 'denied'
    })
    window.clarity?.(
      'set',
      'environment',
      process.env.NODE_ENV || 'development'
    )
  } catch {
    console.warn('[Clarity] Failed to initialize')
  }
}

if (!applyDeviceIdleAction()) {
  startDeviceIdleWatch()
  const root = createRoot(document.getElementById('root'))
  root.render(<App />)
}
